import { PropsWithChildren } from 'react'

import { BlockerComponentProps, BlockerType, useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { setBlockerDescriptorId } from '@cash-web/shared-util-fetch'

import { getRegisteredComponent } from '../blockerComponentRegistry'
import { BlockerStatusResult } from '../BlockerStatusResult/BlockerStatusResult'

export const FlowRenderer = ({ children }: PropsWithChildren) => {
  const flow = useFlowContext()

  // do not render if we are no longer in progress
  if (!flow.isInProgress) {
    return null
  }

  const { blockerData, statusResult } = flow?.active ?? {}
  if (blockerData == null || blockerData.type == null) {
    if (statusResult != null) {
      return (
        <BlockerStatusResult
          result={statusResult}
          onClose={() => {
            flow.complete()
          }}
        />
      )
    }
    return null
  }

  const Component = getRegisteredComponent(blockerData) as React.FC<BlockerComponentProps<BlockerType>>

  if (Component == null) {
    throw Error(`${blockerData.type} blocker has not been implemented`)
  }

  setBlockerDescriptorId({
    id: blockerData?.id,
    groupId: blockerData?.groupId,
  })

  return <Component key={blockerData.id} {...blockerData} />
}
